export const VAIRABLES = {
  PAYPAL_CLIENT_ID:
    "ATAe5g9CDuCQhRQQUhKfQhSuq2GslUa-o4UJDI-lD667YRudkLnCfHkWohnvU73ihchK9yo53Q1HcvxC",
  ENABLE_FUNDING: "venmo",
  DISABLE_FUNDING: "credit,card,bancontact",
  PAYPAL_RETURN_URL: "https://app.auxrideshare.com/success",
  PAYPAL_SUCCESS_URL: "https://app.auxrideshare.com/error",
};
